$(document).ready(function(){
  setTimeout(function(){
    var h = $(".waves-top").height();
    $(".waves-top").css("margin-top", -(h-1));
    $(".waves-top").css("margin-bottom", "-1px");
  }, 100);

  var fwh = $(".footer-waves").height();
  $("#shopify-section-template--15986628919550__1653914588a7c35f61").css("margin-bottom", -fwh);
  $("#shopify-section-template--16535810507006__077b7b36-6216-42dd-aacf-b7c6013ec96a").css("margin-bottom", -fwh);
  $("#shopify-section-template--19554727198974__1653914588a7c35f61").css("margin-bottom", -fwh);

  setTimeout(function(){
    var promo_height = $(".template-collection .grid-product-first").height();
    $(".grid-product .promotional-wrapper").css("min-height", promo_height);
  }, 100);

    $('.featured-collections-section .collection-slider-mobile').slick({
      dots: false,
      arrows: false,
      infinite: true,
      swipe: true,
      swipeToSlide: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

  if($(window).width() < 769){
    $(".text-columns-section.full-width .border-right-waves.medium-up--hide").css({"width": $(window).width(), "max-width": $(window).width()});
  }

  setTimeout(function(){
    if($('.product-single__form').find('.bold_option_set').length === 0){
      $(".bold-option__total-price").hide();
    }
  }, 500);

  $(".shopify-payment-terms").appendTo("#shopify-payment-terms");

  $(".image-with-text-overlay").click(function(){
    $(this).find(".btn").get(0).click();
  });
  $(".celebrity-customers-section").click(function(e){
    if ($(e.target).closest(".slick-arrow").length === 0) {
      $(this).find(".btn").get(0).click();
    }
  });
});

$(window).resize(function(){
  var h = $(".waves-top").height();
  $(".waves-top").css("margin-top", -(h-1));
  $(".waves-top").css("margin-bottom", "-1px");

  var fwh = $(".footer-waves").height();
  $("#shopify-section-template--15986628919550__1653914588a7c35f61").css("margin-bottom", -fwh);
  $("#shopify-section-template--16535810507006__077b7b36-6216-42dd-aacf-b7c6013ec96a").css("margin-bottom", -fwh);

  var promo_height = $(".template-collection .grid-product-first").height();
  $(".grid-product .promotional-wrapper").css("min-height", promo_height);

  if($(window).width() < 769){
    $(".text-columns-section.full-width .border-right-waves.medium-up--hide").css({"width": $(window).width(), "max-width": $(window).width()});
  }
});

$(function(){
  $(".section--testimonials .testimonials-slider").slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });
  $('.testimonials-arrow__left').click(function(){
    $(".section--testimonials .testimonials-slider").slick('slickPrev');
  });
  $('.testimonials-arrow__right').click(function(){
    $(".section--testimonials .testimonials-slider").slick('slickNext');
  });

  $(".section--testimonials-2 .testimonials-slider").slick({
      dots: false,
      arrows: true,
      infinite: false,
      swipe: true,
      swipeToSlide: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: '<div class="icon-arrow arrow-left"><img src="//www.sweetesbakeshop.com/cdn/shop/t/173/assets/arrow-circle-left.png?v=169089797233439126011771072864" alt="Arrow Circle Left Icon"></div>',
      nextArrow: '<div class="icon-arrow arrow-right"><img src="//www.sweetesbakeshop.com/cdn/shop/t/173/assets/arrow-circle-right.png?v=86474342071643155761771072864" alt="Arrow Circle Right Icon"></div>',
      responsive: [{
          breakpoint: 1140,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },{
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 769,
          settings: {
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });

  $(".featured-product-slider").slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: '<div class="icon-arrow arrow-left"><img src="//www.sweetesbakeshop.com/cdn/shop/t/173/assets/arrow-circle-left.png?v=169089797233439126011771072864" alt="Arrow Circle Left Icon"></div>',
      nextArrow: '<div class="icon-arrow arrow-right"><img src="//www.sweetesbakeshop.com/cdn/shop/t/173/assets/arrow-circle-right.png?v=86474342071643155761771072864" alt="Arrow Circle Right Icon"></div>',
      responsive: [
    	{
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 769,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 481,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
  });

  $('.celebrity-customers__slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      swipe: true,
      swipeToSlide: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: '<div class="icon-arrow arrow-left"><img src="//www.sweetesbakeshop.com/cdn/shop/t/173/assets/arrow-circle-left.png?v=169089797233439126011771072864" alt="Arrow Circle Left Icon"></div>',
      nextArrow: '<div class="icon-arrow arrow-right"><img src="//www.sweetesbakeshop.com/cdn/shop/t/173/assets/arrow-circle-right.png?v=86474342071643155761771072864" alt="Arrow Circle Right Icon"></div>',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false
          }
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
          }
        }
      ]
  });

  $('.multicolumn__slider').slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
  });

  $(".drawer__tabs .tab__title").click(function(){
    $(".drawer__tabs .drawer__tab").removeClass("active");
    $(this).parent().toggleClass("active");
  });

  $("body").on("click", ".cart__remove .text-link", function(){
    var id = $(this).data("id");
    $("#cart__item-"+id+" .js-qty__num").val("1");
    $("#cart__item-"+id+" .js-qty__adjust--minus").trigger("click");
  });

  $("#custom-cake-banner-check").click(function(){
    if($(this).is(":checked")){
      $(this).parent().find("#custom-cake-banner-input").show();
    }else{
      $(this).parent().find("#custom-cake-banner-input").hide();
    }
  });
});

$(function () {
    var x = parseInt($(".collection-grid__wrapper").data("paginate"));
    $(".collection-grid__wrapper .product-grid-item").slice(0, x).show();
    $("#loadMore").on('click', function (e) {
        e.preventDefault();
        $(".collection-grid__wrapper .product-grid-item:hidden").slice(0, x).slideDown();
        if ($(".collection-grid__wrapper .product-grid-item:hidden").length == 0) {
            $("#loadMore").fadeOut('slow');
        }
    });
});

$(".order-form__receive-your-order select").change(function(){
  if($(this).val() == 'Delivery (Greater Los Angeles area)'){
    $(".order-form__delivery-address").show();
    $(".order-form__delivery-time").show();
    $(".order-form__delivery-address .input-full").prop("disabled", false);
    $(".order-form__delivery-time .input-full").prop("disabled", false);
    $(".order-form__shipping-address").hide();
    $(".order-form__shipping-address .input-full").prop("disabled", true);
  }else if($(this).val() == 'Nationwide Shipping (Cookies & select desserts only)'){
    $(".order-form__delivery-address").hide();
    $(".order-form__delivery-time").hide();
    $(".order-form__delivery-address .input-full").prop("disabled", true);
    $(".order-form__delivery-time .input-full").prop("disabled", true);
    $(".order-form__shipping-address").show();
    $(".order-form__shipping-address .input-full").prop("disabled", false);
  }else{
    $(".order-form__delivery-address").hide();
    $(".order-form__delivery-time").hide();
    $(".order-form__shipping-address").hide();
    $(".order-form__delivery-address .input-full").prop("disabled", true);
    $(".order-form__delivery-time .input-full").prop("disabled", true);
    $(".order-form__shipping-address .input-full").prop("disabled", true);
  }
});

$(".order-form__desserts select").change(function(){
  if($(this).val() == 'Custom Cake'){
    $(".order-form__custom-cake").show();
    $(".order-form__custom-cookies").hide();
    $(".order-form__custom-cupcakes").hide();
    $(".order-form__dessert-catering").hide();
    $(".order-form__custom-cake .input-full").prop("disabled", false);
    $(".order-form__custom-cookies .input-full").prop("disabled", true);
    $(".order-form__custom-cupcakes .input-full").prop("disabled", true);
    $(".order-form__dessert-catering .input-full").prop("disabled", true);
  }else if($(this).val() == 'Custom Cookies'){
    $(".order-form__custom-cake").hide();
    $(".order-form__custom-cookies").show();
    $(".order-form__custom-cupcakes").hide();
    $(".order-form__dessert-catering").hide();
    $(".order-form__custom-cake .input-full").prop("disabled", true);
    $(".order-form__custom-cookies .input-full").prop("disabled", false);
    $(".order-form__custom-cupcakes .input-full").prop("disabled", true);
    $(".order-form__dessert-catering .input-full").prop("disabled", true);
  }else if($(this).val() == 'Custom Cupcakes'){
    $(".order-form__custom-cake").hide();
    $(".order-form__custom-cookies").hide();
    $(".order-form__custom-cupcakes").show();
    $(".order-form__dessert-catering").hide();
    $(".order-form__custom-cake .input-full").prop("disabled", true);
    $(".order-form__custom-cookies .input-full").prop("disabled", true);
    $(".order-form__custom-cupcakes .input-full").prop("disabled", false);
    $(".order-form__dessert-catering .input-full").prop("disabled", true);
  }else if($(this).val() == 'Dessert Catering'){
    $(".order-form__custom-cake").hide();
    $(".order-form__custom-cookies").hide();
    $(".order-form__custom-cupcakes").hide();
    $(".order-form__dessert-catering").show();
    $(".order-form__custom-cake .input-full").prop("disabled", true);
    $(".order-form__custom-cookies .input-full").prop("disabled", true);
    $(".order-form__custom-cupcakes .input-full").prop("disabled", true);
    $(".order-form__dessert-catering .input-full").prop("disabled", false);
  }else{
    $(".order-form__custom-cake").hide();
    $(".order-form__custom-cookies").hide();
    $(".order-form__custom-cupcakes").hide();
    $(".order-form__dessert-catering").hide();
    $(".order-form__custom-cake .input-full").prop("disabled", true);
    $(".order-form__custom-cookies .input-full").prop("disabled", true);
    $(".order-form__custom-cupcakes .input-full").prop("disabled", true);
    $(".order-form__dessert-catering .input-full").prop("disabled", true);
  }
});

$(".order-form__interested-in select").change(function(){
  if($(this).val() == 'Logo cookies' || $(this).val() == 'Photo cookies'){
    $(".order-form__photo-cookies").show();
    $(".order-form__hand-decorated-cookies").hide();
    $(".order-form__photo-cookies .input-full").prop("disabled", false);
    $(".order-form__hand-decorated-cookies .input-full").prop("disabled", true);
  }else if($(this).val() == 'Hand decorated design cookies'){
    $(".order-form__photo-cookies").hide();
    $(".order-form__hand-decorated-cookies").show();
    $(".order-form__photo-cookies .input-full").prop("disabled", true);
    $(".order-form__hand-decorated-cookies .input-full").prop("disabled", false);
  }else{
    $(".order-form__photo-cookies").hide();
    $(".order-form__hand-decorated-cookies").hide();
    $(".order-form__photo-cookies .input-full").prop("disabled", true);
    $(".order-form__hand-decorated-cookies .input-full").prop("disabled", true);
  }
});

$(document).ready(function(){
  setTimeout(function(){
    $(".flatpickr-days .dayContainer .flatpickr-day").each(function(){
      var d = new Date($(this).attr("aria-label"));
      var today = new Date();
      if(today >= d){
        $(this).addClass("disable");
      }else{
        $(this).removeClass("disable");
      }
    });

    $(".flatpickr-monthDropdown-months").change(function(){
      $(".flatpickr-days .dayContainer .flatpickr-day").each(function(){
        var d = new Date($(this).attr("aria-label"));
        var today = new Date();
        if(today >= d){
          $(this).addClass("disable");
        }else{
          $(this).removeClass("disable");
        }
      });
    });

    $(".flatpickr-prev-month, .flatpickr-next-month").click(function(){
      setTimeout(function(){
        $(".flatpickr-days .dayContainer .flatpickr-day").each(function(){
          var d = new Date($(this).attr("aria-label"));
          var today = new Date();
          if(today >= d){
            $(this).addClass("disable");
          }else{
            $(this).removeClass("disable");
          }
        });
      }, 10);
    });

    // $('.globo-paragraph a[href*="https://cdn.shopify.com/s/files/1/0303/6515/5373/files/cake-flavors.png"]').magnificPopup({
    //   type: 'image',
    //   closeOnContentClick: true,
    //   mainClass: 'globo-popup',
    //   image: {
    //     verticalFit: true
    //   }
    // });
  }, 1000);

  $(".cart__item-qty-update .js-qty__adjust").click(function(){
    var qty = parseInt($(this).parent().find(".js-qty__num").val());
    if($(this).hasClass("js-qty__adjust--minus")){
      if(qty > 0){
        qty = parseInt(qty - 1);
        $(this).parent().find(".js-qty__num").val(qty).trigger("change");
      }
    }else if($(this).hasClass("js-qty__adjust--plus")){
      qty = parseInt(qty + 1);
      $(this).parent().find(".js-qty__num").val(qty).trigger("change");
    }
  });
});

$(window).on("scroll", function () {
  $(".shopify-section").each(function () {
    let sectionTop = $(this).offset().top;
    let sectionHeight = $(this).outerHeight();
    let scrollTop = $(window).scrollTop();
    let windowHeight = $(window).height();

    if (sectionTop < scrollTop + windowHeight && sectionTop + sectionHeight > scrollTop) {
      if ($(this).find("[data-aos]").length > 0) {
        $(this).find("[data-aos]").addClass("aos-animate");
      }
    }
  });
});

/************************************************************************************

* [MAIN-COLLECTION]

*************************************************************************************/

// Hide loadmore button if no more items to load
$(document).ready(function(){
  var n = $('#CollectionAjaxContent .collection-grid__wrapper .grid .product-grid-item').length;
  if(n <= 16){
    $('.collection-grid__loadmore').hide();
  }else{
    $('.collection-grid__loadmore').show();
  }
});

/************************************************************************************

* [MAIN-PRODUCT]

*************************************************************************************/

// Trigger collapsible on the contact section
$(document).ready(function(){
  $(".product-block--tab-contact .collapsible-trigger-btn").trigger("click");
});

// =====================
// Focus Management & Trap Focus
// =====================

function isVisible(element) {
	if (!element) return false

	if (element.closest('[aria-hidden="true"], [hidden]')) return false

	const detailsParent = element.closest('details')
	if (detailsParent && !detailsParent.open && !detailsParent.contains(element.closest('summary'))) {
		return false
	}

	if (element.offsetParent === null && getComputedStyle(element).position !== 'fixed') {
		return false
	}

	const style = getComputedStyle(element)
	if (style.visibility === 'hidden' || style.visibility === 'collapse') return false

	if (element.getClientRects().length === 0) return false

	return true
}

function l_getFocusableElements(container) {
	const focusableSelectors = `summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe`

	return Array.from(container.querySelectorAll(focusableSelectors)).filter((el) => isVisible(el))
}

function l_disableFocusableElements(container) {
	l_getFocusableElements(container).forEach((el) => {
		el.setAttribute('tabindex', '-1')
		el.setAttribute('aria-disabled', 'true')
	})
}

function l_enableFocusableElements(container) {
	l_getFocusableElements(container).forEach((el) => {
		el.removeAttribute('tabindex')
		el.removeAttribute('aria-disabled')
	})
}

const l_trapFocusHandlers = {}

function l_trapFocus(container, defaultElementToFocus, enableFocusRange = true) {
	// cleanup any previous traps
	l_removeTrapFocus()

	l_trapFocusHandlers.keydown = (event) => {
		const key = event.code?.toUpperCase()
		const isTab = key === 'TAB'
		const isArrowDown = key === 'ARROWDOWN'
		const isArrowUp = key === 'ARROWUP'

		const elements = l_getFocusableElements(container)
		const [first, last] = [elements[0], elements[elements.length - 1]]
		const currentIndex = elements.indexOf(event.target)

		if (!elements.length) return

		if (isTab) {
			if ((event.target === last || last?.contains?.(event.target)) && !event.shiftKey) {
				event.preventDefault()
				first?.focus()
			} else if ((event.target === container || first?.contains?.(event.target)) && event.shiftKey) {
				event.preventDefault()
				last?.focus()
			}
			return
		}

		if (isArrowDown) {
			event.preventDefault()
			if (currentIndex === -1 || currentIndex === elements.length - 1) {
				first?.focus()
			} else {
				elements[currentIndex + 1]?.focus()
			}
			return
		}

		if (isArrowUp) {
			event.preventDefault()
			if (currentIndex === -1 || currentIndex === 0) {
				last?.focus()
			} else {
				elements[currentIndex - 1]?.focus()
			}
			return
		}
	}

	l_trapFocusHandlers.focusin = (event) => {
		if (container.contains(event.target)) {
			document.addEventListener('keydown', l_trapFocusHandlers.keydown)
		}
	}

	l_trapFocusHandlers.focusout = () => {
		document.removeEventListener('keydown', l_trapFocusHandlers.keydown)
	}

	document.addEventListener('focusin', l_trapFocusHandlers.focusin)
	document.addEventListener('focusout', l_trapFocusHandlers.focusout)

	// Initial focus
	const elements = l_getFocusableElements(container)
	const first = elements[0]
	const elementToFocus = defaultElementToFocus || first
	if (elementToFocus) {
		elementToFocus.focus()
		if (
			elementToFocus.tagName === 'INPUT' &&
			['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
			elementToFocus.value &&
			enableFocusRange
		) {
			elementToFocus.setSelectionRange(0, elementToFocus.value.length)
		}
	}
}

function l_removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', l_trapFocusHandlers.focusin)
	document.removeEventListener('focusout', l_trapFocusHandlers.focusout)
	document.removeEventListener('keydown', l_trapFocusHandlers.keydown)
	if (elementToFocus) elementToFocus.focus()
}

// =====================
// Scroll & Body Lock Utilities
// =====================

function l_lockBodyScroll(elementName) {
	// Set scrollbar width
	const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
	document.documentElement.style.setProperty('--l-body-scrollbar-width', `${scrollBarWidth}px`)

	// Add classes
	document.body.classList.add('js-block-page')

	if (elementName) {
		document.body.classList.add(`js-block-page-${elementName}`)
	}
}

function l_unLockBodyScroll(elementName) {
	// Remove scrollbar width CSS variables
	document.documentElement.style.removeProperty('--l-body-scrollbar-width')

	// Remove classes
	if (elementName) {
		document.body.classList.remove(`js-block-page-${elementName}`)

		const isExistAnotherBlockedClass = Array.from(document.body.classList).some((cls) =>
			cls.startsWith('js-block-page-')
		)

		!isExistAnotherBlockedClass && document.body.classList.remove('js-block-page')
	} else {
		document.body.classList.remove('js-block-page')
	}
}

function l_setupGlobalVariables() {
	// Set scrollbar width
	const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth

	document.documentElement.style.setProperty('--l-body-locked-width', `${scrollBarWidth}px`)
}

function l_setupVariablesBeforeOpenModal() {
	// // Elements
	// const announcementBarSection = document.getElementById('announcementBar')
	// const headerSection = document.getElementById('header')?.parentElement

	// // Set CSS variables
	// document.documentElement.style.setProperty('--l-viewport-height', `${visualViewport?.height ?? window.innerHeight}px`)
	// document.documentElement.style.setProperty('--l-header-height', `${headerSection?.offsetHeight || 0}px`)
	// document.documentElement.style.setProperty(
	// 	'--l-announcement-bar-height',
	// 	`${announcementBarSection?.offsetHeight || 0}px`
	// )

	// return {
	// 	headerHeight: headerSection?.offsetHeight || 0,
	// 	announcementBarHeight: announcementBarSection?.offsetHeight || 0,
	// 	headerTotalHeight: (headerSection?.offsetHeight || 0) + (announcementBarSection?.offsetHeight || 0),
	// 	viewportHeight: visualViewport?.height ?? window.innerHeight,
	// }
}

function l_initFakeMobileScrollbar() {
	const bar = document.getElementById('l-fake-scrollbar')
	if (!bar) return

	let hideTimeout = null

	const doc = document.documentElement
	const scrollTop = window.scrollY
	const docHeight = doc.scrollHeight
	const winHeight = window.innerHeight

	if (docHeight <= winHeight) {
		bar.style.opacity = 0
		return
	}

	const barHeight = Math.max(winHeight * (winHeight / docHeight), 40)
	const maxScroll = docHeight - winHeight
	const ratio = maxScroll ? scrollTop / maxScroll : 0

	bar.style.height = `${barHeight}px`
	bar.style.transform = `translateY(${ratio * (winHeight - barHeight)}px)`
	bar.style.opacity = 1

	clearTimeout(hideTimeout)
	hideTimeout = setTimeout(() => {
		bar.style.opacity = 0
	}, 1000)
}


/************************************************************************************

* COMPONENT: l-2-tier-property
* DESCRIPTION: This component is used to generate the 2 tier property of the product based on selected variant.
* USAGE:
* <l-2-tier-property>
*   <input type="hidden" name="properties[2 Tier Value]" value="true">
* </l-2-tier-property>

*************************************************************************************/
class LTA2TierLarge extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Elements
    this.variantIdsEl = this.querySelector('[data-variant-ids]')
    this.inputWrapperEl = this.querySelector('[data-input]')

    // Parse variant IDs into an array for accurate matching
    const twoTierLargeVariantIds = this.variantIdsEl.textContent.trim().split(",").map(id => id.trim());
    const currentVariantId = this.dataset.currentVariantId;

    // Utility: Update hidden input based on current variant ID
    const updateInput = (variantId) => {
      const isTwoTierLarge = twoTierLargeVariantIds.includes(variantId);
      this.inputWrapperEl.innerHTML = isTwoTierLarge
        ? `<input type="hidden" name="properties[2 Tier Value]" value="true">`
        : '';
    };

    // Initial render
    if (currentVariantId) {
      updateInput(currentVariantId);
    }

    // Listen for variant change events
    this._onVariantChange = (event) => {
      const variant = event.detail && event.detail.variant;
      if (!variant || !variant.id) return;
      updateInput(String(variant.id));
    };

    document.addEventListener('variant:change', this._onVariantChange);
  }

  disconnectedCallback() {
    // Clean up the event listener
    if (this._onVariantChange) {
      document.removeEventListener('variant:change', this._onVariantChange);
    }
  }
}

customElements.define('l-2-tier-property', LTA2TierLarge);


/************************************************************************************

* COMPONENT: l-drawer
* DESCRIPTION: This component is used to generate the drawer component.

*************************************************************************************/
if (!customElements.get('l-drawer')) {
  class LTADrawer extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.setupDrawer()
    }

    setupDrawer() {
      // Show in body
      const showInBody = this.dataset.showInBody === 'true'

      // Insert to body if needed
      if (showInBody) {
        const mainContentEl = document.getElementById('PageContainer')
        const isInContainer = mainContentEl.contains(this)

        if (isInContainer) {
          document.body.appendChild(this)

          return
        }
      }

      // Insert template content
      const templateEl = this.querySelector('template')
      if (templateEl) {
        const templateContentEl = templateEl.content.cloneNode(true)
        this.appendChild(templateContentEl)
      }

      this.drawer_init()
    }

    drawer_init() {
      // Elements
      this.triggerEls = document.querySelectorAll(this.dataset.triggerSelector)
      this.closeBtnEls = this.querySelectorAll('[data-close]')
      this.drawerInnerEl = this.querySelector('[data-drawer-inner]')
      this.triggerEl = null

      if (this.dataset.closeSelector) {
        const externalCloseBtnEls = document.querySelectorAll(this.dataset.closeSelector)
        this.closeBtnEls = Array.from(this.closeBtnEls).concat(Array.from(externalCloseBtnEls))
      }

      // Data
      this.onlyOneDrawerOpen = this.dataset.onlyOneDrawerOpen === 'true'
      this.drawerName = this.dataset.drawerName || 'drawer'

      // Setup events

      // Close this drawer if another drawer is open
      if (this.onlyOneDrawerOpen) {
        document.addEventListener('l:drawer:open', (event) => {
          if (event.detail.drawerName !== this.drawerName) {
            this.drawer_close()
          }
        })
      }

      // Open event
      console.clear();
      this.triggerEls.forEach((triggerEl) => {
        console.log(triggerEl);

        triggerEl.addEventListener('click', (event) => {
          event.preventDefault()

          this.drawer_open(triggerEl)
        })
      })

      // Close event
      this.closeBtnEls.forEach((closeBtnEl) => {
        closeBtnEl.addEventListener('click', () => {
          this.drawer_close()
        })
      })
    }

    drawer_open(triggerEl) {
      l_setupVariablesBeforeOpenModal()
      l_lockBodyScroll(this.drawerName)

      // Open drawer
      this.classList.add('is-expanding')
      this.classList.remove('l-hidden')

      requestAnimationFrame(() => {
        this.classList.add('is-active')
      })

      // Setup focus trap on main content
      if (triggerEl) {
        this.triggerEl = triggerEl
        l_trapFocus(this.drawerInnerEl, this.defaultElementToFocus)
      }

      // Set up accessibility
      this.setAttribute('aria-expanded', 'true')
      this.removeAttribute('tabindex')

      // Set global events
      window.addEventListener('click', this.drawer_closeOutsideOnClick.bind(this))
      window.addEventListener('keyup', this.drawer_closeOutsideOnEscape.bind(this))

      // Dispatch event to notify that the drawer is open
      document.dispatchEvent(
        new CustomEvent('l:drawer:open', {
          detail: { drawerName: this.drawerName },
        })
      )
    }

    drawer_close() {
      l_unLockBodyScroll(this.drawerName)

      // Close drawer
      this.classList.remove('is-active')

      window.l_debounce(() => {
        this.classList.remove('is-expanding')
        this.classList.add('l-hidden')
      }, 400)()

      // Remove focus trap
      if (this.triggerEl) {
        l_removeTrapFocus(this.triggerEl)
        this.triggerEl = null
      }

      // Remove accessibility
      this.setAttribute('aria-expanded', 'false')
      this.setAttribute('tabindex', '-1')

      // Remove global events
      window.removeEventListener('click', this.drawer_closeOutsideOnClick)
      window.removeEventListener('keyup', this.drawer_closeOutsideOnEscape)
    }

    drawer_closeOutsideOnClick(event) {
      if (!this.classList.contains('is-active')) return

      const target = event.target
      const triggerSelector = this.dataset.drawerTriggerSelector || 'l-drawer-trigger'
      const isDrawerTrigger = event.target.closest(triggerSelector) || event.target.tagName == triggerSelector

      const isOutsideClick =
        !this.drawerInnerEl.contains(target) &&
        !Array.from(this.triggerEls).some((el) => el.contains(target)) &&
        !isDrawerTrigger

      if (isOutsideClick) this.drawer_close()
    }

    drawer_closeOutsideOnEscape(event) {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.drawer_close()
      }
    }
  }

  customElements.define('l-drawer', LTADrawer)
}


/************************************************************************************

* RUN GLOBAL FUNCTIONALITIES / RUN BASE FUNCTIONALITIES

*************************************************************************************/
function l_initializeGlobalEventListeners() {
  l_initFakeMobileScrollbar()

	window.addEventListener('DOMContentLoaded', () => {
		l_setupGlobalVariables()
	})

	window.addEventListener(
		'scroll',
		() => {
			l_initFakeMobileScrollbar()
		},
		{ passive: true }
	)
}

l_initializeGlobalEventListeners()
